import React, { useContext, useEffect, useState, useRef } from 'react';
import FadeIn from 'react-fade-in';
import { Observer } from 'mobx-react-lite';
import { GlobalHotKeys } from 'react-hotkeys';

import { quickDrawerFocus } from '../../_shared/QuickDrawer';
import QuickDrawerHeader from '../../_shared/QuickDrawerHeader';
import HtmlEditor from '../../_shared/HtmlEditor';

import PurchaseUpdateStore from '../../../../stores/PurchaseUpdateStore';
import QuickDrawerStore from '../../../../stores/QuickDrawerStore';
import CacheStore from '../../../../stores/CacheStore';

import * as ErrorMessages from '../../../../constants/errorMessages';
import * as fn from '../../../../utilities/_functions';
import * as ih from '../../../../utilities/invoiceHelper';
import * as oh from '../../../../utilities/operationHelper';

import './NoChargePurchase.scss';

function NoChargePurchase(props) {
    const isMounted = useRef(true);
    const validateRef = useRef(null);
    const noChargeReasonOtherRef = useRef(null);
    const purchase = useContext(PurchaseUpdateStore);
    const quickDrawer = useContext(QuickDrawerStore);
    const cache = useContext(CacheStore);
    const [noChargeReasonKey, setNoChargeReasonKey] = useState(null);

    useEffect(() => {
        quickDrawerFocus(props.drawer);
        return () => {
            isMounted.current = false;
        }
    }, []) // eslint-disable-line

    const handleCancel = () => {
        if (fn.isFunction(props.onCancel)) {
            if (purchase.hasUnsavedChanges) {
                if (window.confirm(ErrorMessages.DISCARD_CHANGES)) {
                    props.onCancel();
                }
            } else {
                props.onCancel();
            }
        }
    }

    const handleNoChargeReasonOption = event => {
        const key = event.target.value;
        setNoChargeReasonKey(key);
        purchase.hasUnsavedChanges = true;
    }

    const handleReasonChange = event => {
        const html = event.value;
        noChargeReasonOtherRef.current = (html ? fn.stripHtml(html) : null);
        purchase.hasUnsavedChanges = true;
    }

    const handleSubmit = event => {
        event.preventDefault();

        if (noChargeReasonKey && noChargeReasonKey !== 'Other') {
            purchase.noChargeType = noChargeReasonKey;
        }
        else {
            purchase.noChargeType = null;
        }

        purchase.noChargeReason = noChargeReasonOtherRef.current;
        purchase.noChargeReasonHtml = noChargeReasonOtherRef.current ? `<p>${noChargeReasonOtherRef.current}</p>` : null;

        purchase.noChargePurchase(true)
            .then(() => {
                if (isMounted.current) {
                    if (props.onSuccess && fn.isFunction(props.onSuccess)) {
                        props.onSuccess(event, purchase.data);
                    }
                }
            })
    }

    return <>
        <Observer>{() =>
            <>
                {
                    (props.drawer === quickDrawer.drawerOpened) ?
                        <GlobalHotKeys
                            keyMap={{
                                close: ['esc'],
                            }}
                            handlers={{
                                close: event => {
                                    handleCancel(event)
                                },
                            }}
                            allowChanges={true}
                        /> : null
                }
            </>
        }</Observer>
        <form ref={validateRef} onSubmit={handleSubmit}>
            <Observer>{() =>
                <fieldset disabled={purchase.isSaving}>
                    <div className='void-purchase-container quick-drawer'>
                        <QuickDrawerHeader
                            drawer={props.drawer}
                            icon={oh.getIcon('purchase', 'no-charge')}
                            action='Purchase'
                            category='No Charge'
                            className=''
                            onCancel={props.onCancel}
                        />
                        <div className='quick-drawer-body'>
                            <FadeIn>
                                <div className='body-content'>
                                    <Observer>{() =>
                                        <>
                                            <section>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className='form-group validate validate-required mb-2'>
                                                            <label className='required'><small>No Charge Reason</small></label>
                                                            {
                                                                cache.getReferenceDataOptions('PurchaseNoChargeType').map((reason, ri) => {
                                                                    return <div
                                                                        key={`no-charge-reason-${ri}`}
                                                                        className='custom-control custom-radio mb-2'
                                                                    >
                                                                        <input
                                                                            id={`no-charge-reason-${ri}`}
                                                                            type='radio'
                                                                            name='no-charge-reason-option'
                                                                            value={reason.key}
                                                                            className='custom-control-input'
                                                                            checked={noChargeReasonKey === reason.key}
                                                                            onChange={handleNoChargeReasonOption}
                                                                        />
                                                                        <label
                                                                            htmlFor={`no-charge-reason-${ri}`}
                                                                            className='custom-control-label'
                                                                        >
                                                                            {ih.getNoChargeDescription(reason.key)}
                                                                        </label>
                                                                    </div>
                                                                })
                                                            }
                                                            <div
                                                                className='custom-control custom-radio'
                                                            >
                                                                <input
                                                                    id='no-charge-reason-other'
                                                                    type='radio'
                                                                    name='no-charge-reason-option'
                                                                    value='Other'
                                                                    className='custom-control-input'
                                                                    checked={noChargeReasonKey === 'Other'}
                                                                    onChange={handleNoChargeReasonOption}
                                                                />
                                                                <label
                                                                    htmlFor='no-charge-reason-other'
                                                                    className='custom-control-label'
                                                                >
                                                                    Other
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className='pl-4'>
                                                            <div className={'input-group' + (noChargeReasonKey === 'Other' ? ' validate validate-required' : '')}>
                                                                <Observer>{() =>
                                                                    <HtmlEditor
                                                                        disableTab={true}
                                                                        onValueChanged={handleReasonChange}
                                                                    />
                                                                }</Observer>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </>
                                    }</Observer>
                                </div>
                            </FadeIn>
                        </div>
                        <div className='quick-drawer-action'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='float-right'>
                                        <button
                                            type='button'
                                            className='btn btn-link btn-cancel mr-2'
                                            onClick={props.onCancel}
                                        >Cancel</button>
                                        <Observer>{() =>
                                            <button
                                                type='submit'
                                                className='btn btn-info'
                                            >Continue</button>
                                        }</Observer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            }</Observer>
        </form>
    </>
}

export default NoChargePurchase;